import {
  EmergencyCall,
  EmergencyCallGerman,
} from "../../api/firebase/types/incident.types";

export const AlarmCategoryTemplate = (emergencyCall: EmergencyCall) => {
  const category = emergencyCall
    ? EmergencyCallGerman[emergencyCall]
    : "Unbekannt";
  return <div>{category}</div>;
};
